import { combineReducers } from 'redux';

import Auth from './auth/reducers';
import Layout from './layout/reducers';
import PageTitle from './pageTitle/reducers';
import AreaReducer from './areas/reducers';
import LandmarkReducer from './landmark/reducers';
import CustomerReducer from './customer/reducers';
import ProductReducer from './product/reducers';
import AllotmentReducer from './allotment/reducers';
import ExpensecategoryReducer from './expenseCategory/reducers';
import DesignationReducer from './designation/reducers';
import SalesReducer from './sales/reducers';
import EmployeeReducer from './employee/reducers';
import BranchReducer from './branch/reducers';
import ExpensesReducer from './expenses/reducers';
import OutstandingReducer from './outstanding/reducers';
import SettingsReducer from './settings/reducers';
import DraftReducer from './draft/reducers';
import CollectionsReducer from './collections/reducers';
import ReturnOrderReducer from './returnOrder/reducers';
import tallyReducer from './tally/reducers';

export default combineReducers({
    Auth,
    Layout,
    PageTitle,
    AreaReducer,
    LandmarkReducer,
    CustomerReducer,
    ProductReducer,
    AllotmentReducer,
    ExpensecategoryReducer,
    DesignationReducer,
    SalesReducer,
    EmployeeReducer,
    BranchReducer,
    ExpensesReducer,
    OutstandingReducer,
    SettingsReducer,
    DraftReducer,
    CollectionsReducer,
    ReturnOrderReducer,
    tallyReducer,
    
    
});
